import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { isEmpty, startCase } from "lodash";
import { FaStickyNote } from "react-icons/fa";
import helpers from "utils/helpers";

const EmployeeTaskList = ({ taskList, page, handleEdit, handleView, handleTask, handleNoteView, setTaskList, unreadMessageCount, handleDelete, handleCancel }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="p-3">
        <div className="border placeholder:overflow-x-auto relative rounded-lg ">
          <table className="text-left w-full text-xs text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-gray-900 text-xs border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-5 py-3">
                  {t("EMPLOYEE_ID")}
                </th>
                <th className="py-3 px-5" scope="col">
                  {t("NAME")}
                </th>
                <th scope="col" className="py-3 px-5">
                  {t("TASK_NAME")}
                </th>
                <th className="px-5 py-3" scope="col">
                  {t("TASK_START_DATE_TIME")}
                </th>
                <th scope="col" className="py-3 px-5">
                  {t("TASK_END_DATE_TIME")}
                </th>
                <th scope="col" className="text-center py-3 px-5 ">
                  {t("TASK_STATE")}
                </th>
                <th scope="col" className="py-3 px-5">
                  {t("TASK_TYPE")}
                </th>
                <th scope="col" className="px-5 text-center py-3 ">
                  {t("O_STATUS")}
                </th>
                <th className="px-5 py-3 text-center" scope="col">
                  {t("TAGS")}
                </th>
                <th scope="col" className="py-3 px-5 text-center">
                  {t("TIME_SPEND_ON_TASK_HOURS")}
                </th>
                <th className="py-3 px-5 text-center " scope="col">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {taskList &&
                taskList.map((item, i) => {
                  return (
                    <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="py-5 px-5 border-r text-gray-900">{item?.employee?.employeeId}</td>
                      <td className="py-5 px-5 border-r text-gray-900">{item?.employee?.name}</td>
                      <td className="py-5 px-5 border-r text-gray-900">{item?.name}</td>
                      <td className="py-5 px-5 border-r text-gray-900">{dayjs(item?.startDateTime).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="py-5 px-5 border-r text-gray-900 text-left">{dayjs(item?.endDateTime).format("MM-DD-YYYY h:mm A")} </td>
                      <td className="py-5 px-5 border-r text-gray-900 text-center">{startCase(item?.state)}</td>
                      <td className="py-5 px-5 border-r text-gray-900">
                        <span className={`px-2 py-1 rounded-full text-xs ${
                          item.taskType === 'shift' 
                            ? 'bg-purple-100 text-purple-700' 
                            : 'bg-blue-100 text-blue-700'
                        }`}>
                          {item.taskType === 'shift' ? 'Shift' : 'Standalone'}
                        </span>
                      </td>
                      <td className="py-5 px-5 border-r text-gray-900 text-center">{startCase(item?.status)}</td>
                      <td className="py-5 px-5 border-r text-gray-900 text-center">{startCase(item?.tags)}</td>
                      <td className="py-5 px-5 border-r text-gray-900 text-center">{helpers.calculateTotalTaskTime(item?.timeLogs)}</td>
                      <td className="py-5 px-5 border-l text-gray-900 text-center">
                        <div className="flex flex-col">
                          <div className="flex justify-center mb-2">
                            {item?.state === "done" ? (
                              ""
                            ) : (
                              <span
                                title="Reassign task"
                                className="border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap cursor-pointer bg-LightBlue flex text-xs px-2 ml-2 py-1  rounded-lg items-center"
                                onClick={() => handleTask(item)}
                              >
                                Reassign
                              </span>
                            )}
                            {item?.status === "canceled" || item?.state === "done" ? (
                              ""
                            ) : (
                            <span
                                title="Cancel task"
                                className="border border-transparent text-white hover:bg-red-700 whitespace-nowrap cursor-pointer bg-red-600 flex text-xs px-2 ml-2 py-1 rounded-lg items-center"
                                onClick={() => {
                                  helpers.alertFunction(
                                    `Are you sure want to cancel '${item.name}'?`,
                                    item._id,
                                    handleCancel,
                                    true
                                  );
                                }}
                              >
                                Cancel
                              </span>)}
                          </div>
                          <ul className="flex justify-center">

                            <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <a title="Edit" className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                {" "}
                                <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                              </a>
                            </li>
                            <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                              <a title="View">
                                {" "}
                                <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                              </a>
                            </li>
                            <li onClick={() => {
                                  helpers.alertFunction(
                                    `Are you sure want to delete '${item.name}'?`,
                                    item._id,
                                    handleDelete,
                                    true
                                  );
                                }} className="px-2 py-2 hover:bg-white hover:text-slate-800">
                            <a title="Delete">
                              <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />
                            </a>
                          </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(taskList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-5 px-5 border-r" colSpan={11}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTaskList;
